import React from 'react';
import PropTypes from 'prop-types';

import i18n from '../../i18n';

const PromoGPInfoLabel = (props) => (
    <div className="row">
        <div className="col-sm-10 promo-gp">
            {i18n.t('exchange:promo-gp.info', { gpAmount: props.amount })}
        </div>
    </div>
);

PromoGPInfoLabel.propTypes = {
    amount: PropTypes.number.isRequired
};

export default PromoGPInfoLabel;
